
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/payment-methods",
      function () {
        return require("private-next-pages/policy/payment-methods.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/payment-methods"])
      });
    }
  